import { createPromiseClient } from '@bufbuild/connect-web';
import { StructureManager } from '@/generated/msh/service/v1/structure_manager_connectweb';
import { GetStructuresRequest } from '@/generated/msh/service/v1/structure_manager_pb';
import { transport } from '../transport';

const client = createPromiseClient(StructureManager, transport);
const StatusMapping = {
  0: 'UNSPECIFIED',
  1: 'ABSENT',
  2: 'PRESENT',
  3: 'UNKNOWN',
};

export async function fetchResidents(
  { parentId, pagination, withActiveAlerts },
  signal
) {
  const response = await client.getStructures(
    new GetStructuresRequest({
      parentId,
      recursive: true,
      withActiveAlerts,
      page: {
        cursor: pagination?.cursor || '',
        perPage: '9999',
      },
    }),
    { signal }
  );

  const residents = response.structures
    .filter((structure) => Boolean(structure.type.value.resident))
    .map((structure) => ({
      structureId: structure.type.value.structureId,
      label: structure.type.value.label,
      presenceStatus: StatusMapping[structure.type.value.presenceStatus],
      alerts: structure.type.value.alerts,
      rooms: structure.type.value.rooms,
      devices: structure.type.value.devices,
      user: structure.type.value.resident,
    }));
  const meta = response.page;

  return { residents, meta };
}
